export let customerColumns = [
	{
		attr: "first_name",
		label: "Наименование",
		type: 1
	}, {
		attr: "ppt_id",
		label: "ID",
		type: 1
	}, {
		attr: "ppt_inn",
		label: "INN",
		type: 1
	}, {
		attr: "phone",
		label: "Тел. номер",
		type: 1
	}, {
		attr: "address",
		label: "Адрес",
		type: 1
	}, {
		attr: "email",
		label: "Email",
		type: 1
	}, {
		attr: "passport",
		label: "Passport detail",
		type: 1
	}, {
		attr: "created_date",
		label: "Register At",
		type: 1
	}
]